import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconTranslateAlt$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconTranslateAlt extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '375d5a7c9c189f61a8af9cdd2d5a651f8a4989d4', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'd101a1384aca8512dcfd836799494cd109fb1ed1', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '7370ce032263126b718b9579e6592af73baffc7f', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.5 2a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5H10v7.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5H12V2.5a.5.5 0 0 0-.5-.5zm4 1.5h1V5H10v1H8.972q-.024.173-.074.389a4.65 4.65 0 0 1-1.114 2.044 9 9 0 0 0 1.088.592 12 12 0 0 0 1.25.49l.018.005.005.002-.29.957h-.002l-.006-.003-.024-.007a7 7 0 0 1-.385-.131c-.252-.092-.6-.227-.985-.405A9 9 0 0 1 7 9.11a9 9 0 0 1-1.453.824 13 13 0 0 1-1.37.536l-.024.007-.006.002h-.002S4.144 10.48 4 10s-.144-.478-.145-.478l.005-.002.017-.005a6 6 0 0 0 .345-.118c.232-.084.553-.209.906-.372a9 9 0 0 0 1.088-.592l-.095-.107a4.65 4.65 0 0 1-1.02-1.937A4 4 0 0 1 5.029 6H4V5h2.5zm.62 4.174a3 3 0 0 1-.12.132 3.65 3.65 0 0 1-.926-1.652A3 3 0 0 1 6.04 6h1.918q-.014.072-.033.154c-.096.398-.314.949-.805 1.52m6.939 4.476c.316-.885 1.567-.885 1.883 0L18 18h-1l-.725-2h-2.55L13 18h-1zm.941.336L15.912 15h-1.824zM18 5v2h-1V5h-2V4h2a1 1 0 0 1 1 1M4 17v-2h1v2h2v1H5a1 1 0 0 1-1-1", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-translate-alt", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-translate-alt"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-translate-alt":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconTranslateAlt$1);
            }
            break;
    } });
}

const CosmosIconTranslateAlt = CosmosIconTranslateAlt$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconTranslateAlt, defineCustomElement };
